module.exports = __webpack_public_path__ + "img/donante-farmacia-la-mas-barata.bf0d3be6.png";